import type { ConditionalRule } from './api';

const num = (v: unknown): number | null => {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(String(v).replace(',', '.').replace(/\s/g, ''));
  return Number.isFinite(n) ? n : null;
};

const text = (v: unknown) => String(v ?? '').toLowerCase();

/** Одно правило против одного значения. Сравнение числовое, если оба числа. */
export function matchRule(rule: ConditionalRule, value: unknown): boolean {
  const empty = value === null || value === undefined || value === '';

  switch (rule.op) {
    case 'empty':
      return empty;
    case 'notempty':
      return !empty;
    case 'contains':
      return !empty && text(value).includes(text(rule.value));
    case 'notcontains':
      return !text(value).includes(text(rule.value));
    case 'eq':
    case 'ne': {
      const a = num(value);
      const b = num(rule.value);
      const equal = a !== null && b !== null ? a === b : text(value) === text(rule.value);
      return rule.op === 'eq' ? equal : !equal;
    }
    case 'gt':
    case 'lt': {
      const a = num(value);
      const b = num(rule.value);
      if (a === null || b === null) return false;
      return rule.op === 'gt' ? a > b : a < b;
    }
    case 'between': {
      const a = num(value);
      const from = num(rule.value);
      const to = num(rule.value2);
      if (a === null || from === null || to === null) return false;
      return a >= Math.min(from, to) && a <= Math.max(from, to);
    }
    default:
      return false;
  }
}
